<template>
    <v-card class="workspace-dashboard__upload-card" elevation="0" data-home-tour-upload-card>
        <div class="workspace-dashboard__section-head">
            <div>
                <div class="workspace-dashboard__section-kicker">Upload</div>
                <h2>Upload New Dataset</h2>
            </div>
            <v-icon size="28">$vuetify.icons.upload</v-icon>
        </div>
        <p>
            Upload processed DJI Terra, Agisoft, Pix4D, RealityCapture, or supported
            SmartData hosted datasets.
        </p>
        <div class="workspace-dashboard__upload-platforms">
            <span
                v-for="platform in uploadPlatforms"
                :key="platform"
                class="workspace-dashboard__upload-platform"
            >
                {{ platform }}
            </span>
        </div>
        <div class="workspace-dashboard__quota-list">
            <div>
                <span>Dataset quota</span>
                <strong>{{ datasetQuotaLabel }}</strong>
            </div>
            <div>
                <span>Storage quota</span>
                <strong>{{ storageQuotaLabel }}</strong>
            </div>
            <div>
                <span>Seat allowance</span>
                <strong>{{ seatsQuotaLabel }}</strong>
            </div>
        </div>
        <div class="workspace-dashboard__upload-actions">
            <v-btn color="primary" block :href="summary.links?.upload || '/upload'">
                Start Upload
            </v-btn>
            <v-btn
                variant="text"
                block
                :href="summary.links?.docs || 'https://help.ndsmartdata.com/en/'"
            >
                Learn about supported formats
            </v-btn>
        </div>
    </v-card>
</template>

<script>
export default {
    name: 'DashboardUploadCard',
    props: {
        summary: {
            type: Object,
            default: () => ({}),
        },
        uploadPlatforms: {
            type: Array,
            default: () => [],
        },
        datasetQuotaLabel: {
            type: String,
            default: '',
        },
        storageQuotaLabel: {
            type: String,
            default: '',
        },
        seatsQuotaLabel: {
            type: String,
            default: '',
        },
    },
};
</script>
